import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Cronitor from "@cronitorio/cronitor-rum";
import App from "./app";
import telemetry from "./telemetry";
import reportWebVitals from "./report-web-vitals";
import { getEnvironment } from "./utils/environment";
import config from "./config";
import LDProvider from "./launch-darkley-provider";

telemetry.initialize();

async function startApp() {
  const environment = getEnvironment();
  const container = document.getElementById("root");

  // // Start MSW in development
  // if (environment === "local" && process.env.NODE_ENV === "development") {
  //   const { worker } = await import("./mocks/browser");
  //   await worker.start({
  //     onUnhandledRequest: "bypass",
  //   });
  // }

  if (environment !== "local") {
    Cronitor.load(config.cronitorClientKey, {
      environment,
      trackMode: "pageload",
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(container!);

  const AsyncLdProvider = await LDProvider();

  root.render(
    <React.StrictMode>
      <AsyncLdProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AsyncLdProvider>
    </React.StrictMode>,
  );

  reportWebVitals();
}

startApp();
